/**
 * Created by Vladislav on 27.03.2025.
 */

const RepairProgressView = cc.Node.extend({
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.progressBar = Prefab.instantiate(bundles.new_task_progress_bar.jsons.newtaskprogressbar_prefab_json, {
            noIcons: true
        });
        this.addChild(this.progressBar);
        this.updateSize();
        this.setCascadeOpacityEnabledRecursively(true);

        cleverapps.UI.applyHover(this);
        cleverapps.UI.onClick(this, this.onPressed.bind(this));

        const location = cleverapps.meta.getSelectedLocation();
        location.on("animateProgress", this.animateProgress.bind(this), this);
        location.on("changeStars", this.onChangeStars.bind(this), this);
        location.on("reset", this.onLocationReset.bind(this), this);
    },

    updateSize: function () {
        const bar = this.progressBar;
        const icon = ComponentUtils.findChildByName(bar, "icon");

        let bounds = cc.rect(0, 0, bar.width, bar.height);
        if (icon) {
            bounds = cc.rectUnion(bounds, icon.getBoundingBox());
        }

        this.setContentSize(bounds.width, bounds.height);
        bar.setPosition(bar.width * bar.anchorX - bounds.x, bar.height * bar.anchorY - bounds.y);
    },

    stopFade: function () {
        if (this.fadeAction) {
            this.stopAction(this.fadeAction);
            delete this.fadeAction;
        }
    },

    showAnimation: function (silent) {
        this.stopFade();
        this.setVisible(true);

        if (silent) {
            this.setOpacity(255);
            return;
        }

        this.setOpacity(0);
        this.fadeAction = this.runAction(new cc.FadeIn(RepairProgressView.FADE_DURATION)).setFinalize(() => {
            this.setOpacity(255);
        });
    },

    hideAnimation: function (silent) {
        this.stopFade();

        if (silent) {
            this.setOpacity(255);
            this.setVisible(false);
            return;
        }

        this.fadeAction = this.runAction(new cc.Sequence(
            new cc.FadeOut(RepairProgressView.FADE_DURATION),
            new cc.Hide()
        )).setFinalize(() => {
            this.setOpacity(255);
            this.setVisible(false);
        });
    },

    onChangeStage: function (options) {
        const location = cleverapps.meta.getSelectedLocation();

        this.progressBar.setPercentage(location.stageNo, options);

        if (this.showProgressAction) {
            this.stopAction(this.showProgressAction);
            delete this.showProgressAction;
        }

        if (location.stars.isEnoughStars()) {
            this.showProgressAction = this.runAction(new cc.Sequence(
                new cc.DelayTime(0.6),
                new cc.CallFunc(() => {
                    this.progressBar.showProgressNext();
                })
            ));
        } else {
            this.progressBar.hideProgressNext();
        }
    },

    onChangeStars: function () {
        const location = cleverapps.meta.getSelectedLocation();

        if (this.showProgressAction) {
            this.stopAction(this.showProgressAction);
            delete this.showProgressAction;
        }

        if (location.stars.isEnoughStars()) {
            this.progressBar.showProgressNext();
        } else {
            this.progressBar.hideProgressNext();
        }
    },

    animateProgress: function () {
        this.onChangeStage({
            animated: HidingComponent.isNodeShown(this.getParent())
        });
    },

    onLocationReset: function () {
        this.onChangeStage();
    },

    onPressed: function () {
        cleverapps.meta.getSelectedLocation().displayNewTaskWindow();
    }
});

RepairProgressView.FADE_DURATION = 0.15;
